import { getHashedDocumentId } from '@fluidframework/odsp-driver';
import { ActivityTracker, NamespaceLoggerAdapter } from '@fluidx/telemetry';
import { getInformationProtectionFromCache } from './utilities/InformationProtectionCacheUtilities';
/**
 * Helper method which enables caching the watermark and IRM Capabilities
 * for the given file. The caching is done by Information Protection Service.
 *  @param informationProtectionServicePromise The information protection service promise.
 *  @param resolvedUrl The resolved url of the file
 */
export function preCacheInformationProtection(informationProtectionServicePromise, resolvedUrl, logger) {
    const cacheInformationProtection = async (informationProtectionServicePromise, resolvedUrl) => {
        const mipLogger = logger ? new NamespaceLoggerAdapter('InformationProtectionService', logger) : undefined;
        const tracker = ActivityTracker.start('precacheInformationProtection', mipLogger, {
            addUserTiming: true,
            isAPerformanceMetric: true
        });
        // As part of preCaching we also will also cache MIP data in local storage.
        getInformationProtectionFromCache(resolvedUrl, mipLogger);
        try {
            const informationProtectionService = await informationProtectionServicePromise;
            await Promise.all([
                informationProtectionService.getIrmInformation(resolvedUrl),
                informationProtectionService.getWatermarkInformation(resolvedUrl)
            ]);
        }
        catch {
            /* getIrmInformation & getWatermarkingInformation already handle and log errors */
            tracker.setResult(false /*succeeded*/);
        }
        tracker.setResult(true /*succeeded*/);
    };
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    cacheInformationProtection(informationProtectionServicePromise, resolvedUrl);
}
export async function preCacheInformationProtectionWithSharePointIds(informationProtectionServicePromise, siteUrl, driveId, fileId, logger) {
    getHashedDocumentId(driveId, fileId)
        .then((hashedDocumentId) => {
        // Filling enough information in IOdspResolvedUrl to get information protection and cache
        const resolvedUrl = {
            siteUrl,
            driveId,
            itemId: fileId,
            odspResolvedUrl: true,
            hashedDocumentId,
            type: 'fluid',
            id: '',
            url: '',
            tokens: {},
            endpoints: {
                snapshotStorageUrl: '',
                attachmentPOSTStorageUrl: '',
                attachmentGETStorageUrl: '',
                deltaStorageUrl: ''
            },
            fileName: '',
            summarizer: false,
            fileVersion: ''
        };
        preCacheInformationProtection(informationProtectionServicePromise, resolvedUrl, logger);
    })
        .catch(() => { }); // best effort to precache
}
//# sourceMappingURL=preCacheInformationProtection.js.map